<template>
    <div class="row">
        <div class="col-sm-3"></div>
        <div class="col-sm-6">
            <div class="consultas">
                <h2>¿Tienes dudas con este trámite?</h2>
                <label v-if="channels_institution.titulo_dinamico">
                    Comunícate con {{ channels_institution.institution.name }}
                </label>
                <label v-else>
                    {{ channels_institution.sub_titulo }}
                </label>
                <ul class="redes-consultas">
                    <li v-for="channel in channels">
                        <a :href="channel.url" target="_blank">
                            <img :src="channel.icono" :alt="`Ícono ${channel.url}`">
                        </a>
                    </li>
                </ul>
            </div>
        </div>
        <div class="col-sm-3"></div>
    </div>
</template>

<script>
    export default {
        name: "HelpChannelShowBack",
        data (){
            const channel = _.cloneDeep(this.channel);
            const channels_institution = _.cloneDeep(this.channels_institution);
            
            return{
                channels: channels,
                channels_institution: channels_institution,
            }
        },
        props: ['channels','channels_institution'],
    }
</script>

<style scoped>
    li a{
        list-style: none;
        margin-left:3px;
    }
    img{
        width: 28px !important;
        height: 28px !important;
    }
    ul{
        margin:0;
    }

    a  {
        font-family: Roboto;
        text-decoration: underline;
    }

</style>
